import {
  Agriculture,
  BackupTable,
  Dashboard,
  LocalShipping,
  Newspaper,
  ShoppingCart,
  Storefront,
} from "@mui/icons-material";

export const adminPuncakMenuData = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    path: "/admin",
    items: [],
  },
  {
    title: "Master Data",
    icon: <BackupTable />,
    items: [
      {
        title: "Tipe Harga",
        path: "/admin/tipe-harga",
      },
      {
        title: "Customer Group",
        path: "/admin/customer-group",
      },
      {
        title: "Customer Region",
        path: "/admin/customer-region",
      },
      {
        title: "Kategori Produk",
        path: "/admin/kategori-produk",
      },
      {
        title: "Kendaraan Pengiriman",
        path: "/admin/kendaraan-pengiriman",
      },
      {
        title: "Produk Operational",
        path: "/admin/produk-operational",
      },
    ],
  },
  {
    title: "Sayuran",
    icon: <ShoppingCart />,
    items: [
      {
        title: "Harga Sayuran",
        path: "/admin/harga-sayuran",
      },
      {
        title: "Sayuran",
        path: "/admin/sayuran",
      },
    ],
  },
  {
    title: "Customer",
    icon: <Storefront />,
    path: "/admin/customer",
    items: [],
  },
  {
    title: "Stock",
    icon: <LocalShipping />,
    items: [
      {
        title: "Stock Sayuran",
        path: "/admin/stock-sayuran",
      },
      {
        title: "Stock Barang",
        path: "/admin/stock-barang-operational",
      },
    ],
  },
  {
    title: "Hutang",
    icon: <Agriculture />,
    items: [
      {
        title: "Hutang Plastik",
        path: "/petani/hutang-plastik",
      },
      {
        title: "Hutang Petani",
        path: "/petani/hutang",
      },
    ],
  },
  {
    title: "Nota Petani",
    icon: <Newspaper />,
    path: "/petani/nota-petani",
    items: [],
  },
  {
    title: "Nota Toko",
    icon: <Newspaper />,
    path: "/admin/po-toko",
    items: [],
  },
  {
    title: "Surat Jalan",
    icon: <Newspaper />,
    path: "/admin/surat-jalan",
    items: [],
  },
  {
    title: "Pengajuan Operasional",
    icon: <Newspaper />,
    path: "/admin/pengajuan-operasional",
    items: [],
  },
];
